import { renderLegend } from "../helpers/RenderLegend";
import { renderFormattedMonth } from "../helpers/FormatDate";

export const renderHeader = (month, calendar) => {
    let headHTML = ``;

    headHTML += `<div class="calendar__header">`;
    headHTML += `	<nav class="calendar__nav-container">`;
    headHTML += `		<button class="calendar__nav calendar__nav--prev"><span class="screen-reader-text">Previous</span><span class="arrow"></span></button>`;
    headHTML += `		<h3>${renderFormattedMonth(month)}</h3>`;
    headHTML += `		<button class="calendar__nav calendar__nav--next"><span class="screen-reader-text">Next</span><span class="arrow"></span></button>`;
    headHTML += `	</nav>`;
	// Display the legend
	if (calendar.dataset.type !== 'twomonth' && calendar.dataset.layout == 'legend_top') {
		headHTML += renderLegend();
	}
    headHTML += `</div>`;

    return headHTML;
}

export const renderFooter = (calendar) => {
	let footHTML = ``;
	// Display the legend
	if (calendar.dataset.layout == 'legend_bottom') {
		footHTML += `<div class="calendar__footer">`;
		footHTML += renderLegend();
		footHTML += `</div>`;
	}

    return footHTML;
}
